// What the console shows for each managed resource type.
//
// `primary` are the metrics a user reads to answer "is it being used, and how
// much" — they drive the resource card summary and the default chart. `storage`
// is the accumulating capacity metric, shown separately because it is a rate
// (GB-hour / GB-day), not an operation count.
//
// Metrics the management API does not return are simply not rendered. Nothing
// here describes Cloudflare capabilities the console has not wired up.
export const resourceProfiles = {
  KV_NAMESPACE: {
    primary: ['KV_READ', 'KV_WRITE', 'KV_DELETE', 'KV_LIST'],
    storage: 'KV_STORAGE_GB_HOUR',
  },
  D1_DATABASE: {
    primary: ['D1_ROWS_READ', 'D1_ROWS_WRITTEN'],
    storage: 'D1_STORAGE_GB_HOUR',
  },
  R2_BUCKET: {
    primary: [
      'R2_CLASS_A_OPERATION',
      'R2_CLASS_B_OPERATION',
      'R2_IA_CLASS_A_OPERATION',
      'R2_IA_CLASS_B_OPERATION',
    ],
    storage: 'R2_STORAGE_GB_DAY',
  },
  DURABLE_OBJECT: {
    primary: ['DO_REQUEST', 'DO_ROWS_READ', 'DO_ROWS_WRITTEN'],
    storage: 'DO_STORAGE_GB_HOUR',
  },
  QUEUE: {
    primary: ['QUEUE_OPERATION'],
    storage: null,
  },
  WORKFLOW: {
    primary: ['WORKFLOW_INVOCATION', 'WORKFLOW_STEP'],
    storage: 'WORKFLOW_STORAGE_GB_HOUR',
  },
};

export const unknownResourceProfile = { primary: [], storage: null };

export const profileFor = (type) =>
  resourceProfiles[type] || unknownResourceProfile;

// Where a resource sits. The only provisioning field worth surfacing: it decides
// how far the data is from the user, and managed placement can now target it.
export const resourceLocation = (resource) => {
  const config = resource?.config || {};
  return (
    config.location ||
    config.created_in_region ||
    config.jurisdiction ||
    resource?.placement?.location ||
    null
  );
};
